import React, { useState, useEffect } from "react";
import "./Form6.scss";
import { FiArrowRight, FiX } from "react-icons/fi";
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const Form6 = (props) => {
  const [skill, setSkills] = React.useState([]);
  const data = [
    {
      name: "Juice World",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Drake",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Tylor Swift",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "J Balvin",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Bad Bunny",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Travis Scrott",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "The Weeknd",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "BTS",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Ozuna",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Drake",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Tylor Swift",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "J Balvin",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Bad Bunny",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Travis Scrott",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "The Weeknd",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "BTS",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      name: "Ozuna",
      img:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
  ];

  const disabledBtn = () => {
    if (!skill.length)
      return true;
    return false;
  };

  const handleSubmit = async() => {
    await props.signup({
      userId: props.userData.signupData.userId,
      favourite_artist: skill,
    });
    props.clicking();
  };

  return (
    <div className="Form6 w-100">
      <div className="h1">My favorite artist ...</div>
      <div className="note text-muted text-left">Select up to 3 artist</div>
      {/* <div className="input-wrapper">
        <input
          type="search"
          className="input form-control"
          placeholder="Search"
          required
        />
      </div> */}
      <div className="skills">
        {skill.map((item, i) => (
          <div className="skill" key={i}>
            <img src={item.img} alt="" />
            {item.name}
            <FiX
              className="ml-3"
              onClick={(e) => {
                setSkills(
                  skill.filter(function (skl) {
                    return skl.name !== item.name;
                  })
                );
              }}
            />
          </div>
        ))}
      </div>
      <div className="skills-selected">
        {data.map((item, i) => (
          <div
            className="skill"
            key={i}
            onClick={() => setSkills([...skill, item])}
          >
            <img src={item.img} alt="" />
            {item.name}
          </div>
        ))}
      </div>

      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          disabled={disabledBtn()}
          onClick={() => handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
});

export default connect(mapStateToProps, {
  signup,
})(Form6);
